import { Toast } from 'antd-mobile'
import type { ToastShowProps } from 'antd-mobile'

export const showToast = (content: string, opt?: ToastShowProps) => {
  Toast.show({ content, ...(opt || {}) })
}

export const clearToast = () => {
  Toast.clear()
}
